import { Check, Copy } from 'lucide-react'
import { useCallback, useState } from 'react'

export function CopyToClipboard({ text, className, tooltip }: { text: string; className?: string; tooltip?: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 1500)
  }, [text])

  const label = tooltip ?? 'Copy to clipboard'

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={copied ? 'Copied' : label}
      title={label}
      className={`p-1 rounded text-gray-500 hover:bg-gray-800 hover:text-gray-300 transition-colors focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1 ${className ?? ''}`}
    >
      {copied ? (
        <Check
          aria-hidden="true"
          className="size-3.5 text-green-400"
        />
      ) : (
        <Copy
          aria-hidden="true"
          className="size-3.5"
        />
      )}
    </button>
  )
}
